import React, { useState, useEffect, useContext } from "react";
import * as FaIcons from "react-icons/fa";
import EditCourseTable from "./EditCoursesTable";
import SearchForm from "./SearchForm";
// import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const EditCourseList = ({ items, courseid,permalink }) => {
  const [filteredItems, setFilteredItems] = useState(items);
  const listView = true;
  // const adminRegistrationContext = useContext(AdminRegistrationContext);
  // const { searchCourseLelo } = adminRegistrationContext;

  useEffect(() => {
    if (items) {
      setFilteredItems(items);
    }
  }, [items]);

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\,\/0-9:]/g, "\\$&");
  };
  const searchFilter = (text) => {
    const lowercasedText = escapeRegExp(text.toLowerCase());
    const filtered = items.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(lowercasedText)
      )
    );
    setFilteredItems(filtered);
  };

  const clearSearchFilter = () => {
    setFilteredItems(items);
  };

  return (
    <div className="forms-list">
      <SearchForm
        placeholderText="Search Fields"
        searchFilter={searchFilter}
        clearSearchFilter={clearSearchFilter}
      />
      {/* <p className="num-count">{`${items.length} Sites`}</p> */}
      {listView ? (
        <EditCourseTable
          items={filteredItems}
          courseid={courseid}
          permalink={permalink}
        />
      ) : (
        <div className="interest-complete">
          <FaIcons.FaCheckSquare className="done-icon" />
          <p>Looks like we're out of courses to process</p>
        </div>
      )}
    </div>
  );
};

export default EditCourseList;
